import { LayoutHeader } from '@/components/domains/layouts'
import PolicyBeforePrivacy from '@/components/domains/policy/PolicyBeforePrivacy20230731'

const PagePolicyBeforePrivacy20230731 = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyBeforePrivacy />
    </>
  )
}

export default PagePolicyBeforePrivacy20230731
